module.exports = __webpack_public_path__ + "static/media/2.d64b9ff1.png";